import React from "react";

import logo1 from "../../../assets/home_logos/gardaworld-logo.webp";
import logo2 from "../../../assets/home_logos/lifetime-logo.webp";
import logo3 from "../../../assets/home_logos/pacific-bells-logo.webp";
import logo4 from "../../../assets/home_logos/gardaworld-logo.webp";
import logo5 from "../../../assets/home_logos/lifetime-logo.webp";
import logo6 from "../../../assets/home_logos/pacific-bells-logo.webp";
import logo7 from "../../../assets/home_logos/pacific-bells-logo.webp";
import logo8 from "../../../assets/home_logos/pacific-bells-logo.webp";

function LogoSection() {
  const logos = [
    logo1,
    logo2,
    logo3,
    logo4,
    logo5,
    logo6,
    logo7,
    logo8,
  ];

  return (
    <>
    <section className="bg-white py-14 lg:py-16 overflow-hidden">
      
      {/* ANIMATION */}
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>

      {/* TITLE */}
      <h2
  className="
    text-center

    text-[21px]
    md:text-[20px]
    md:font-extrabold
    lg:text-[20px]

    font-sans
    lg:font-sans

    text-[#0b1d3a]

    mb-10
    lg:mb-[50px]
  "
>
  Trusted by leading companies
</h2>

      {/* LOGO SLIDER */}
      <div className="relative w-full overflow-hidden">

        {/* LEFT FADE */}
        <div className="absolute left-0 top-0 h-full w-16 bg-gradient-to-r from-[#f5f5f5] to-transparent z-10"></div>

        {/* RIGHT FADE */}
        <div className="absolute right-0 top-0 h-full w-16 bg-gradient-to-l from-[#f5f5f5] to-transparent z-10"></div>

        <div
          className="flex gap-12 w-max"
          style={{
            animation: "scroll 25s linear infinite",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.animationPlayState = "paused")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.animationPlayState = "running")
          }
        >
          {[...logos, ...logos].map((logo, i) => (
            <img
              key={i}
              src={logo}
              alt="logo"
              className="
    h-6
    sm:h-6
    md:h-7
    lg:h-8
    xl:h-6

    object-contain
  "
            />
          ))}
        </div>
      </div>

    </section>

    <section className="bg-white py-7 sm:py-14 lg:py-16">
  <div
    className="
      max-w-[1650px]
      md:w-full
      mx-auto

      px-6
      sm:px-8
      lg:px-16
    "
  >
    <div
      className="
        text-[#676B75]
        text-[12px]
        font-bold
        sm:text-[15px]
        md:text-[14px]
        lg:text-[14px]

        leading-[20px]

        space-y-3
         ml-0
    lg:ml-12
   lg:-mt-[40px]
        -my-4
      "
    >
      <p>
        * On-Demand Pay requires employer participation in DailyPay.
        On-Demand Pay fees will be waived for any DailyPay transfers
        made to a DailyPay Card set up with direct deposit. Instant
        Transfers may not be available to residents in all states.
        Please see this{" "}
        <a
          href="/"
          className="underline hover:text-black transition-all font-bold text-[#767373]"
        >
          Help Center article
        </a>{" "}
        for further information.
      </p>

      <p>
        <sup>1</sup> Cash Back rewards earned on qualifying purchases
        will generally be transferred to your Card Account within
        49 days after the qualifying purchase is settled. If you
        close your Card Account, any earned Cash Back rewards not
        yet transferred to your Card Account will be forfeited.
        See the{" "}
        <a
          href="/"
          className="underline hover:text-black transition-all font-bold text-[#767373]"
        >
          DailyPay Cash Back Program Terms & Conditions
        </a>{" "}
        for full details.
      </p>

      <p>
        Cash Back offers are shown for illustrative purposes only.
        Cash back amounts vary and are subject to the individual
        terms of the retailer. See the DailyPay app for more
        information.
      </p>

      <p>
        <sup>1</sup> Bill Manager services are provided in conjunction
        with a third party, ScribeUp, a DailyPay Partner. ScribeUp
        will only identify transactions in accounts that are integrated
        into the service by you. Enrollment is acceptance of the third
        party Privacy Policy and Bill Manager program terms and
        conditions.
      </p>
    </div>
  </div>
</section>

    </>

  );
}

export default LogoSection;